import { registerSessionReset, sessionIsCurrent, sessionTicket } from './sessionLifecycle';
// At most one blocked chime is retained, never a burst of stale sounds.
let pending = null;
let listening = false;
function clear() {
  pending = null;
  if (listening) {
    window.removeEventListener('pointerdown', resume);
    window.removeEventListener('keydown', resume);
    listening = false;
  }
}
function resume() {
  const next = pending;
  clear();
  if (next && sessionIsCurrent(next.ticket) && next.allowed()) attempt(next, false);
}
function attempt(entry, retry) {
  try {
    const audio = new Audio(entry.file);
    Promise.resolve(audio.play()).catch(error => {
      if (!sessionIsCurrent(entry.ticket) || !entry.allowed()) return;
      if (error?.name === 'NotAllowedError' && retry) {
        pending = entry;
        if (!listening) {
          listening = true;
          window.addEventListener('pointerdown', resume);
          window.addEventListener('keydown', resume);
          console.info('Notification sound is waiting for a click or keypress.');
        }
      } else console.warn('Notification sound could not play.', error?.name || 'Audio error');
    });
  } catch (error) { console.warn('Notification sound could not play.', error?.name || 'Audio error'); }
}
export function playNotificationSound(file, allowed = () => true) {
  if (!file || !allowed()) return false;
  attempt({ file, allowed, ticket: sessionTicket() }, true);
  return true;
}
registerSessionReset(clear);
